import styled from 'styled-components';
import MuiTextField from '@material-ui/core/TextField';

export const StyledMuiTextField = styled(MuiTextField)`
  &:hover {
    &,
    .MuiFormLabel-root {
      color: #17181A;
    }

    fieldset {
      border-color: #525866;
    }
  }

  .MuiFormLabel-root {
    color: #525866;

    &.Mui-focused {
      color: #26427C;
      font-weight: 700;
    }

    &.Mui-error {
      color: #CC2942;
    }

    &.Mui-disabled {
      color: #525866;
    }
  }

  .MuiInput-root {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 5px 10px;

    .MuiInput-root:after,
    .MuiInput-root:before {
      display: none;
    }

    input,
    svg {
      color: #fff;
    }

    input::placeholder {
      color: rgba(255, 255, 255, 0.7)
    }
  }

  .MuiOutlinedInput-root {
    fieldset {
      border-color: #CFD6E6;
    }

    &.Mui-focused {
      color: #26427C;

      fieldset {
        border-color: #26427C;
        border-width: 2px;
      }
    }

    &.Mui-error {
      color: #CC2942;

      fieldset {
        border-color: #CC2942;
        border-width: 2px;
      }
    }

    &.Mui-disabled {
      color: #CFD6E6;

      fieldset {
        border-color: #CFD6E6;
      }
    }
  }

  .MuiFormHelperText-root {
    font-weight: 700;
    color: #17181A;

    &.Mui-focused {
      color: #26427C;
    }

    &.Mui-error {
      color: #CC2942;
    }

    &.Mui-disabled {
      color: #525866;
    }
  }
`;
